export default __webpack_public_path__ + "static/media/customer-service-banner.1f4e999e.png";